import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

const LAST_UPDATED = 'June 1, 2025';

function Terms() {
	return (
		<>
			<Helmet>
				<title>Terms of Service | A-Z Home Improvement LLC</title>
				<meta name="description" content="Terms of service for A-Z Home Improvement LLC, Phoenix, AZ home remodeling contractor." />
			</Helmet>
			<PageHeader title="Terms of Service" subtitle={`Last updated: ${LAST_UPDATED}`} />

			<section className="section">
				<div className="container" style={{ maxWidth: 760 }}>
					<p>These Terms of Service ("Terms") govern your use of the A-Z Home Improvement LLC website at azhomefundingservices.com and your engagement with our remodeling and renovation services. By using this website or requesting our services, you agree to these Terms.</p>

					<h2>1. Company Information</h2>
					<p>A-Z Home Improvement LLC is a limited liability company registered in Arizona. Our office is located at 3842 W. McDowell Rd, Suite 110, Phoenix, AZ 85009. AZ ROC License #XXXXX8142.</p>

					<h2>2. Website Use</h2>
					<p>You may use this website for lawful purposes only. You agree not to:</p>
					<ul>
						<li>Submit false or misleading information via the contact form.</li>
						<li>Attempt to gain unauthorized access to our systems.</li>
						<li>Use automated tools to scrape or harvest data from the site.</li>
						<li>Impersonate A-Z Home Improvement or any of its personnel.</li>
					</ul>

					<h2>3. Service Estimates</h2>
					<p>Free estimates provided by A-Z Home Improvement are valid for 30 days from the date of issue. Estimates are based on the scope of work described at the time of the consultation. Changes to the scope of work may result in revised pricing, which will be communicated in writing before work proceeds.</p>

					<h2>4. Contractor Relationship</h2>
					<p>A-Z Home Improvement LLC is an independent contractor. Nothing in these Terms creates an employment or partnership relationship between A-Z and the customer. A-Z retains professional discretion over the methods and manner of performing work within the agreed scope.</p>

					<h2>5. Permits and Code Compliance</h2>
					<p>A-Z Home Improvement pulls all required building permits and performs work in compliance with applicable Arizona building codes and manufacturer specifications. The customer agrees to provide access to the property as needed for permitting inspections.</p>

					<h2>6. Warranty</h2>
					<p>A-Z Home Improvement warrants all workmanship for a period of five (5) years from the date of project completion. This warranty covers defects in installation and craftsmanship and does not cover damage resulting from misuse, accidents, acts of nature, or third-party modifications. Materials are warranted under manufacturer's warranties.</p>

					<h2>7. Payment Terms</h2>
					<p>Payment schedules are outlined in the project contract. A deposit is required before materials are ordered. Milestone payments are tied to project completion stages. Final payment is due upon satisfactory completion and acceptance of the project.</p>

					<h2>8. Limitation of Liability</h2>
					<p>A-Z Home Improvement's total liability for any claim arising from the provision of services is limited to the amount actually paid by the customer for the specific service at issue. We are not liable for indirect, incidental, or consequential damages.</p>

					<h2>9. Dispute Resolution</h2>
					<p>Disputes that cannot be resolved informally will be submitted to binding arbitration under the rules of the American Arbitration Association (AAA) in Maricopa County, Arizona. The prevailing party may be awarded reasonable attorney's fees and costs at the arbitrator's discretion.</p>

					<h2>10. Governing Law</h2>
					<p>These Terms are governed by the laws of the State of Arizona, without regard to its conflict-of-law provisions.</p>

					<h2>11. Changes to Terms</h2>
					<p>We may update these Terms at any time. Continued use of the website after changes are posted constitutes acceptance of the revised Terms.</p>

					<h2>12. Contact</h2>
					<address style={{ fontStyle: 'normal', background: '#f4f4f4', borderRadius: 8, padding: 20, marginTop: 4 }}>
						<strong>A-Z Home Improvement LLC</strong><br />
						3842 W. McDowell Rd, Suite 110<br />
						Phoenix, AZ 85009<br />
						Phone: <a href="tel:+16023902536" style={{ color: 'var(--brand)' }}>(602) 390-2536</a><br />
						Email: <a href="mailto:info@azhomefundingservices.com" style={{ color: 'var(--brand)' }}>info@azhomefundingservices.com</a>
					</address>
				</div>
			</section>
		</>
	);
}

export default Terms;
